export const rcOptions = [
  { label: "AS 1", value: "AS1" },
  { label: "AS 2", value: "AS2" },
  { label: "AS 3", value: "AS3" },
  { label: "AS 4", value: "AS4" },
  { label: "AS 5", value: "AS5" },
  { label: "AS 6", value: "AS6" },
  { label: "AS 7", value: "AS7" },
  { label: "AS 8", value: "AS8" },
  { label: "AS 9", value: "AS9" },

  { label: "BS 1", value: "BS1" },
  { label: "BS 2", value: "BS2" },
  { label: "BS 3", value: "BS3" },
  { label: "BS 4", value: "BS4" },
  { label: "BS 5", value: "BS5" },
  { label: "BS 6", value: "BS6" },
  { label: "BS 7", value: "BS7" },
  { label: "BS 8", value: "BS8" },
  { label: "BS 9", value: "BS9" },

  { label: "CS 1", value: "CS1" },
  { label: "CS 2", value: "CS2" },
  { label: "CS 3", value: "CS3" },
  { label: "CS 4", value: "CS4" },
  { label: "CS 5", value: "CS5" },
  { label: "CS 6", value: "CS6" },
  { label: "CS 7", value: "CS7" },
  { label: "CS 8", value: "CS8" },
  { label: "CS 9", value: "CS9" },

  { label: "DS 1", value: "DS1" },
  { label: "DS 2", value: "DS2" },
  { label: "DS 3", value: "DS3" },
  { label: "DS 4", value: "DS4" },
  { label: "DS 5", value: "DS5" },
  { label: "DS 6", value: "DS6" },
  { label: "DS 7", value: "DS7" },
  { label: "DS 8", value: "DS8" },
  { label: "DS 9", value: "DS9" },

  { label: "ES 1", value: "ES1" },
  { label: "ES 2", value: "ES2" },
  { label: "ES 3", value: "ES3" },
  { label: "ES 4", value: "ES4" },
  { label: "ES 5", value: "ES5" },
  { label: "ES 6", value: "ES6" },
  { label: "ES 7", value: "ES7" },
  { label: "ES 8", value: "ES8" },
  { label: "ES 9", value: "ES9" },

  { label: "FS 1", value: "FS1" },
  { label: "FS 2", value: "FS2" },
  { label: "FS 3", value: "FS3" },
  { label: "FS 4", value: "FS4" },
  { label: "FS 5", value: "FS5" },
  { label: "FS 6", value: "FS6" },
  { label: "FS 7", value: "FS7" },
  { label: "FS 8", value: "FS8" },
  { label: "FS 9", value: "FS9" },

  { label: "GS 1", value: "GS1" },
  { label: "GS 2", value: "GS2" },
  { label: "GS 3", value: "GS3" },
  { label: "GS 4", value: "GS4" },
  { label: "GS 5", value: "GS5" },
  { label: "GS 6", value: "GS6" },
  { label: "GS 7", value: "GS7" },
  { label: "GS 8", value: "GS8" },
  { label: "GS 9", value: "GS9" },

  { label: "HS 1", value: "HS1" },
  { label: "HS 2", value: "HS2" },
  { label: "HS 3", value: "HS3" },
  { label: "HS 4", value: "HS4" },
  { label: "HS 5", value: "HS5" },
  { label: "HS 6", value: "HS6" },
  { label: "HS 7", value: "HS7" },
  { label: "HS 8", value: "HS8" },
  { label: "HS 9", value: "HS9" },

  { label: "IS 1", value: "IS1" },
  { label: "IS 2", value: "IS2" },
  { label: "IS 3", value: "IS3" },
  { label: "IS 4", value: "IS4" },
  { label: "IS 5", value: "IS5" },
  { label: "IS 6", value: "IS6" },
  { label: "IS 7", value: "IS7" },
  { label: "IS 8", value: "IS8" },
  { label: "IS 9", value: "IS9" },
];
